import React from 'react'
import NodeTreeSelect from '../components/NodeTreeSelect'
import NodeTreeSelectMultiple from '../components/NodeTreeSelectMultiple'
import { app } from 'xadmin'

const ModelNodeSelectComponent = (props) => {

  const { model, input, field, placeholder, defaultValue, multiple, nodeJump } = props
  const [value, setValue] = React.useState(input?.value || defaultValue)

  React.useEffect(() => {
    input?.onChange(defaultValue)
  }, [defaultValue])

  const onChange = (item) => {
    setValue(item)
    input?.onChange(item)
    nodeJump && item && app.go(`/app/model/node/${item.id}/view`)
  }

  return (
    <div>
      {multiple ?
        <NodeTreeSelectMultiple {...props} input={{ ...input, value: value instanceof Array ? value : value ? [value] : [], onChange }} field={{ ...field, placeholder, schema: {model} }} /> :
        <NodeTreeSelect {...props} input={{ ...input, value, onChange }} field={{ ...field, placeholder, model }} />
      }
    </div>
  )
}

const paramSchema = {
  type: 'object',
  properties: {
    model: {
      title: '模型',
      type: 'array',
      fieldType: 'modelselect_multip',
      items: {},
    },
    multiple: {
      type: 'boolean',
      title: '多选',
      field: {
        effect: ( { value: multiple }, form ) => {
          form.setFieldData('nodeJump', { display: !multiple })
          multiple && form.change('nodeJump', false)
        }
      }
    },
    nodeJump: {
      type: 'boolean',
      title: '资产画面跳转',
    },
    placeholder: {
      title: '提示文字',
      type: 'string',
      description: '选择器中的提示文本信息'
    }
  },
  formEffect: form => {
    form.useField('multiple', state => {
      let value = state.value
      form.setFieldData('nodeJump', { display: !value })
      value && form.change('nodeJump', false)
    })
  },
}

const ModelNodeSelect = {
  title: '模型资产选择器',
  category: '业务选择器',
  icon: require('../icon/模型资产选择器.svg'),
  component: ModelNodeSelectComponent,
  paramSchema: paramSchema,
  fieldWidget: true,
  initParam: { placeholder: '请选择资产' },
  initLayout: { width: 160, height: 40 },
  theme: [
    { selector: '.ant-select .ant-select-selector', title: '选择器样式' }
  ]
}

export default ModelNodeSelect
